import script from "./GeneralCommentsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralCommentsBlock.vue?vue&type=script&setup=true&lang=js"

import "./GeneralCommentsBlock.vue?vue&type=style&index=0&id=76731726&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76731726"]])

export default __exports__